// keep main file in routes so that once all users are on advanced ui, we can use advanced routing.
import LoadPageTutorProfile from 'src/routes/LoadPageTutorProfile/LoadPageTutorProfile'
export default LoadPageTutorProfile
